import { gql } from 'graphql-tag'

export const incentiveSalesCorrectionFactorQuery = gql`
  query IncentiveSalesCorrectionFactors {
    incentiveSalesCorrectionFactors {
      year
      factors {
        id
        year
        month
        factor
      }
    }
  }
`

export const upsertIncentiveSalesCorrectionFactorMutation = gql`
  mutation UpsertIncentiveSalesCorrectionFactor($data: IncentiveSalesCorrectionFactorYearlyInput!) {
    upsertIncentiveSalesCorrectionFactor(data: $data) {
      year
      factors {
        id
        year
        month
        factor
      }
    }
  }
`
